var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-icon',{attrs:{"color":_vm.$colors.sunglow,"icon":"fas fa-star"}})],1),_c('Card',[_c('ui-icon',{attrs:{"color":_vm.$colors.sunglow,"icon":"fas fa-star","disabled":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }